/**
 * Created by huzhongchun on 2018/4/13.
 */
import React from 'react';
import {
	Route
} from 'react-router-dom';
import AsyncComponent from 'components/public/asyncComponent';
import util from 'util/util';
import Index from 'containers/thefair/index';
import Qs from 'util/queryString';

//由于页面过多，尽量使用AsyncComponent动态加载组件，避免主包过大
//每新加的路由，加上用途的注释
//路由的path最后一级名称必须有项目的前缀，以便区分不同的入口

let basePath = util.getRouteBaseUrl();
const routes = [{
		path: '/',
		exact: true,
		component: Index
	},
	{
		path: '/2021_year_moment/activity_a', // 2021年度瞬间
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/2021YearMoment/a'))
	},
	{
		path: '/2021_year_moment/activity_b', // 2021年度瞬间
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/2021YearMoment/b'))
	},
	{
		path: '/2021_year_moment/activity_c', // 2021年度瞬间
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/2021YearMoment/c'))
	},
	{
		path: '/2021_year_moment/activity_d', // 2021年度瞬间
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/2021YearMoment/d'))
	},
	{
		path: '/2021_year_moment/activity_e', // 2021年度瞬间
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/2021YearMoment/e'))
	},
	{
		path: '/deep_night/thefair_story_list', //交换：深夜故事
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/exchange/deepNight/index'))
	},
	{
		path: '/golden_week/thefair_collect', //交换：研究所X48CP 黄金周旅行交换活动
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/exchange/goldenWeek/index'))
	},
	{
		path: '/good_night/thefair_index', //晚安短信
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/goodNight/getGoodNight/index'))
	},
	{
		path: '/good_night/thefair_get_surprise', //晚安短信
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/goodNight/getSurprise/index'))
	},
	{
		path: '/good_night/thefair_end', //晚安短信
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/goodNight/end/index'))
	},
	{
		path: '/good_night/thefair_my_share', //晚安短信
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/goodNight/myShare/index'))
	},
	{
		path: '/good_night/thefair_share_landing', //晚安短信
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/goodNight/shareLanding/index'))
	},
	{
		path: '/good_night/thefair_video', //晚安短信
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/goodNight/video/index'))
	},
	{
		path: '/good_night/thefair_middle_page', //晚安短信
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/goodNight/middlePage/index'))
	},
	{
		path: '/good_night/thefair_new_landing', //晚安短信
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/goodNight/newLanding/index'))
	},

	{
		path: '/good_night_2019/thefair2019_index', //晚安短信
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/goodNight2019/getGoodNight/index'))
	},
	{
		path: '/good_night_2019/thefair2019_map', //晚安短信
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/goodNight2019/map/index'))
	},
	{
		path: '/good_night_2019/thefair2019_get_surprise', //晚安短信
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/goodNight2019/getSurprise/index'))
	},
	{
		path: '/good_night_2019/thefair2019_end', //晚安短信
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/goodNight2019/end/index'))
	},
	{
		path: '/good_night_2019/thefair2019_hidden', //晚安短信
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/goodNight2019/wechatHidden/index'))
	},
	{
		path: '/good_night_2019/thefair2019_my_share', //晚安短信
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/goodNight2019/myShare/index'))
	},
	{
		path: '/good_night_2019/thefair2019_share_landing', //晚安短信
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/goodNight2019/shareLanding/index'))
	},
	{
		path: '/good_night_2019/thefair2019_video', //晚安短信
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/goodNight2019/video/index'))
	},
	{
		path: '/good_night_2019/thefair2019_app_index', //晚安短信
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/goodNight2019/appIndex/index'))
	},
	{
		path: '/good_night_2019/thefair2019_middle_page', //晚安短信
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/goodNight2019/middlePage/index'))
	},
	{
		path: '/good_night_2019/thefair2019_new_landing', //晚安短信
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/goodNight2019/newLanding/index'))
	},
	{
		path: '/good_night_2019/thefair2019_hubei', //晚安短信
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/goodHubei/getGoodNight/index'))
	},
	{
		path: '/good_night_2019/thefair2019_hubei_app_index', //晚安短信
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/goodHubei/appIndex/index'))
	},
	{
		path: '/good_night_2019/thefair2019_hubei_my_share', //晚安短信
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/goodHubei/myShare/index'))
	},
	{
		path: '/good_night_2019/thefair2019_hubei_get_surprise', //晚安短信
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/goodHubei/getSurprise/index'))
	},
	{
		path: '/good_night_2019/thefair2019_hubei_end', //晚安短信
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/goodHubei/end/index'))
	},
	{
		path: '/good_night_2019/thefair2019_hubei_share_landing', //晚安短信
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/goodHubei/shareLanding/index'))
	},
	{
		path: '/good_book_union/thefair_collect', //好书联盟问卷
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/goodBookUnion/collect/index'))
	},

	{
		path: '/kindle/thefair_kindle', //kindle
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/kindle/video'))
	},


	{
		path: '/thousand/activity_index', //新世相第1000篇文章
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/thousand/index/index'))
	},
	{
		path: '/thousand/activity_edit', //新世相第1000篇文章,填写事件
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/thousand/edit/index'))
	},
	{
		path: '/thousand/activity_share', //新世相第1000篇文章,分享
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/thousand/share/index'))
	},
	{
		path: '/thousand/activity_share_land', //新世相第1000篇文章,分享落地页
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/thousand/shareLand/index'))
	},
	{
		path: '/thousand/activity_complete', //新世相第1000篇文章,分享落地页
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/thousand/complete/index'))
	},

	{
		path: '/thousand/ba_challenge/activity_index', //新世相第1000篇文章(ba挑战)
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/thousand/BAChallenge/index/index'))
	},
	{
		path: '/thousand/ba_challenge/activity_edit', //新世相第1000篇文章,填写事件(ba挑战)
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/thousand/BAChallenge/edit/index'))
	},
	{
		path: '/thousand/ba_challenge/activity_share', //新世相第1000篇文章,分享(ba挑战)
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/thousand/BAChallenge/share/index'))
	},
	{
		path: '/thousand/ba_challenge/activity_share_land', //新世相第1000篇文章,分享落地页(ba挑战)
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/thousand/BAChallenge/shareLand/index'))
	},
	{
		path: '/thousand/ba_challenge/activity_complete', //新世相第1000篇文章,分享落地页(ba挑战)
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/thousand/BAChallenge/complete/index'))
	},
	{
		path: '/thousand/ba_challenge/activity_clear', //新世相第1000篇文章,分享落地页(ba挑战)
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/thousand/BAChallenge/clear/index'))
	},

	// 我和我的祖国
	{
		path: '/thousand/motherland/activity_index',
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/thousand/motherland/index/index'))
	},
	{
		path: '/thousand/motherland/activity_edit',
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/thousand/motherland/edit/index'))
	},
	{
		path: '/thousand/motherland/activity_share',
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/thousand/motherland/share/index'))
	},
	{
		path: '/thousand/motherland/activity_share_land',
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/thousand/motherland/shareLand/index'))
	},
	{
		path: '/thousand/motherland/activity_clear',
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/thousand/motherland/clear/index'))
	},
	{
		path: '/thousand/motherland/activity_open',
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/thousand/motherland/open/index'))
	},
	{
		path: '/thousand/motherland/activity_clear',
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/thousand/motherland/clear/index'))
	},

	// 崩溃逃生出口
	{
		path: '/crashExit/activity_index', // 分发页
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/crashExit/index'))
	},
	{
		path: '/crashExit/activity_landForPasserby', //
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/crashExit/landForPasserby'))
	},
	{
		path: '/crashExit/activity_landForSelf', //
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/crashExit/landForSelf'))
	},
	{
		path: '/crashExit/activity_returnVisit', //
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/crashExit/returnVisit'))
	},
	{
		path: '/crashExit/activity_returnVisitFinished', //
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/crashExit/returnVisitFinished'))
	},
	// 春联大作战
	{
		path: '/couplets/activity_open', //开屏
		exact: true,
		component: AsyncComponent(() => import('src/containers/thefair/couplets/open'))
	},
	{
		path: '/couplets/activity_index', //首页
		exact: true,
		component: AsyncComponent(() => import('src/containers/thefair/couplets/index'))
	},
	{
		path: '/couplets/activity_extract', //抽取页
		exact: true,
		component: AsyncComponent(() => import('src/containers/thefair/couplets/extract'))
	},
	{
		path: '/couplets/activity_result', //结果
		exact: true,
		component: AsyncComponent(() => import('src/containers/thefair/couplets/result'))
	},
	{
		path: '/couplets/activity_star', //明星 地址
		exact: true,
		component: AsyncComponent(() => import('src/containers/thefair/couplets/star'))
	},
	{
		path: '/mock_login',
		exact: true,
		component: AsyncComponent(() => import('containers/mockLogin/index'))
	},
	// 2020晚安短信
	{
		path: '/good_night_2020/home',
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/goodNight2020/home'))
	},
	{
		path: '/good_night_2020/sign_up',
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/goodNight2020/signUp'))
	},
	{
		path: '/good_night_2020/all_star',
		exact: true,
		component: AsyncComponent(() => import('src/containers/thefair/goodNight2020/allStarGoodNight'))
	},

	//夸夸树洞
	{
		path: '/kuakua/thefair_index', //首页
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/kuakuaTreeHole/index'))
	},
	{
		path: '/kuakua/thefair_square', //广场页
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/kuakuaTreeHole/square'))
	},
	{
		path: '/kuakua/thefair_hotSquare', //热门求夸
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/kuakuaTreeHole/hotSquare'))
	},
	{
		path: '/kuakua/thefair_dynamic', //单条动态页
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/kuakuaTreeHole/dynamic'))
	},
	{
		path: '/kuakua/thefair_mine', //个人主页
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/kuakuaTreeHole/mine'))
	},
	{
		path: '/kuakua/thefair_release', //发布动态页
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/kuakuaTreeHole/release'))
	},


	// 世界微笑日
	{
		path: '/worldSmile/activity_index', // 分发页
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/worldSmile/index'))
	},
	{
		path: '/worldSmile/activity_landForPasserby', //
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/worldSmile/landForPasserby'))
	},
	{
		path: '/worldSmile/activity_landForSelf', //
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/worldSmile/landForSelf'))
	},
	{
		path: '/worldSmile/activity_returnVisit', //
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/worldSmile/returnVisit'))
	},
	{
		path: '/worldSmile/activity_returnVisitFinished', //
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/worldSmile/returnVisitFinished'))
	},

	//晚安短信2021
	{
		path: '/good_night_2021/home',
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/goodNight2021/home'))
	},
	{
		path: '/good_night_2021/sign_up',
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/goodNight2021/signUp'))
	},
	{
		path: '/good_night_2021/message',
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/goodNight2021/message'))
	},
	{
		path: '/good_night_2021/poster',
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/goodNight2021/poster'))
	},
	//晚安短信2022
	{
		path: '/good_night_2022/activity_home',
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/goodNight2022/home'))
	},
	{
		path: '/good_night_2022/activity_sign_up',
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/goodNight2022/signUp'))
	},
	{
		path: '/good_night_2022/activity_message',
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/goodNight2022/message'))
	},
	{
		path: '/good_night_2022/activity_poster',
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/goodNight2022/poster'))
	},
	{
		path: '/good_night_2022/activity_end',
		exact: true,
		component: AsyncComponent(() => import('containers/thefair/goodNight2022/activityEnd'))
	},

	//NotFound必须放在最后面
	{
		path: '',
		exact: true,
		component: AsyncComponent(() => import('containers/notFound/index'))
	}

];

const RouteWithSubRoutes = route => {
	let Component = route.component;
	return <Route
	render = {
		props => {
			let query = Qs.parse(props.location.search);
			return <Component {
				...props
			}
			query = {
				query
			}
			routes = {
				route.routes
			}
			/>;
		}
	}
	/>;
};

let routesList = routes.map((route, i) => {
	route.path = basePath + ((route.path === '/' && basePath) ? '' : route.path);
	return <RouteWithSubRoutes key = {
		i
	} {
		...route
	}
	/>;
});
export default routesList;



// WEBPACK FOOTER //
// ./src/router/thefair/routesList.js